
import React, { useState, useEffect, useRef } from "react";
import {
  Tabs,
  Button,
  Table,
  Switch,
  message,
  Spin,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  InputNumber,

  Row,
  Col,
  Tag,
  Upload,
  Radio
} from "antd";
import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  InboxOutlined,

  UpOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { PincodeService } from "../../../services/api/pincode";
import { getHubList } from "../../../services/api/hub";
import InputSearchComponent from "../CommonComponents/InputSearchComponent";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import "./style.scss";

import constants from "../../../constants/constants";

const { TabPane } = Tabs;
const { Option } = Select;
const { Dragger } = Upload;

/*const filterIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75C0 0.335786 0.335786 0 0.75 0H11.25C11.6642 0 12 0.335786 12 0.75C12 1.16421 11.6642 1.5 11.25 1.5Z"
      fill="#8C8C8C"
    />
    <path
      d="M9 4.5H3C2.58579 4.5 2.25 4.16421 2.25 3.75C2.25 3.33579 2.58579 3 3 3H9C9.41421 3 9.75 3.33579 9.75 3.75C9.75 4.16421 9.41421 4.5 9 4.5Z"
      fill="#8C8C8C"
    />
    <path
      d="M6.75 7.5H5.25C4.83579 7.5 4.5 7.16421 4.5 6.75C4.5 6.33579 4.83579 6 5.25 6H6.75C7.16421 6 7.5 6.33579 7.5 6.75C7.5 7.16421 7.16421 7.5 6.75 7.5Z"
      fill="#8C8C8C"
    />
  </svg>
);*/

const { ROLES } = constants;

const PincodeManagement = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [userRoles] = useState(() => {
    try {
      const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
      return userinfo.roles || [];
    } catch (e) {
      console.error("Error parsing userinfo from localStorage", e);
      return [];
    }
  });

  const writeRoles = [
    ROLES.HO_ADMIN,
    ROLES.DEVELOPER,
    ROLES.ROLE_FUNCTIONALHEAD,
  ];

  const hasWriteAccess = userRoles.some(role => writeRoles.includes(role));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // "add" or "edit"
  const [editingKey, setEditingKey] = useState("");
  const [editingTransitDays, setEditingTransitDays] = useState(null);
  const [editingPickupHours, setEditingPickupHours] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [addEntryMode, setAddEntryMode] = useState("bulk"); // "bulk" | "manual"
  const [manualMetadataCities, setManualMetadataCities] = useState([]);
  const [isActiveToggle, setIsActiveToggle] = useState(false);
  const [hubList, setHubList] = useState([]);
  const [editingHub, setEditingHub] = useState(null);

  // Hyperlocal State
  const [stateList, setStateList] = useState([]);
  const [hyperlocalStateList, setHyperlocalStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [hyperlocalState, setHyperlocalState] = useState(null);
  const [hyperlocalCity, setHyperlocalCity] = useState(null);
  const [zoneList, setZoneList] = useState([]);
  const [collapsedZones, setCollapsedZones] = useState({});

  // Create Zone Modal State
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [newZoneName, setNewZoneName] = useState("");
  const [pincodeSearch, setPincodeSearch] = useState("");
  const [availablePincodes, setAvailablePincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]); // Array of entire pincode objects or ids
  const [formattedLoading, setFormattedLoading] = useState(false);

  // Hyperlocal edit zone modal
  const [editZoneModalVisible, setEditZoneModalVisible] = useState(false);
  const [editingZone, setEditingZone] = useState(null);
  const [editZoneName, setEditZoneName] = useState("");
  const [editPincodeSearch, setEditPincodeSearch] = useState("");
  const [editAvailablePincodes, setEditAvailablePincodes] = useState([]);
  const [editSelectedPincodes, setEditSelectedPincodes] = useState([]);
  const [editOrderProcessType, setEditOrderProcessType] = useState("NORMAL");
  const [editAcceptNormalOrder, setEditAcceptNormalOrder] = useState(false);
  const [editAcceptSubscriptionOrder, setEditAcceptSubscriptionOrder] = useState(false);
  const [editZoneLoading, setEditZoneLoading] = useState(false);

  // Manage Zone Modal State
  const [manageZoneModalVisible, setManageZoneModalVisible] = useState(false);

  const [manageZoneTableData, setManageZoneTableData] = useState([]);
  const [manageZoneTotal, setManageZoneTotal] = useState(0);
  const [manageZoneLoading, setManageZoneLoading] = useState(false);
  const [manageZonePage, setManageZonePage] = useState(1);

  // Bulk Update State
  const [bulkEcommZone, setBulkEcommZone] = useState("");
  const [bulkCourierZone, setBulkCourierZone] = useState("");
  const [bulkEcommBillingZone, setBulkEcommBillingZone] = useState("");
  const [bulkCourierBillingZone, setBulkCourierBillingZone] = useState("");

  const [ecommZoneList, setEcommZoneList] = useState([]);
  const [courierZoneList, setCourierZoneList] = useState([]);
  const [ecommBillingZoneList, setEcommBillingZoneList] = useState([]);
  const [courierBillingZoneList, setCourierBillingZoneList] = useState([]);

  // Create Entity Modal State
  const [createEntityModalVisible, setCreateEntityModalVisible] = useState(false);
  const [entityType, setEntityType] = useState("zone"); // "zone" or "billing"
  const [newEntityName, setNewEntityName] = useState("");
  const [newEntityBusinessLine, setNewEntityBusinessLine] = useState("ecomm");

  // Selection & Search State
  const [manageZoneSearchText, setManageZoneSearchText] = useState("");
  const [filters, setFilters] = useState({});
  const [cityFilterList, setCityFilterList] = useState([]); // Cities for filter dropdown
  const [selectedStateForFilter, setSelectedStateForFilter] = useState(null); // { id, name }
  const [bulkPincodeText, setBulkPincodeText] = useState(""); // Input text for pincodes
  const [bulkPincodeList, setBulkPincodeList] = useState([]); // Array of selected pincodes as tags
  
  // Failed Pincodes Modal State
  const [failedPincodesModalVisible, setFailedPincodesModalVisible] = useState(false);
  const [failedPincodesData, setFailedPincodesData] = useState({ successCount: 0, failedPincodes: [] });

  // Bulk Upload Errors Modal State
  const [uploadErrorModalVisible, setUploadErrorModalVisible] = useState(false);
  const [uploadErrorData, setUploadErrorData] = useState([]);
  const [uploadSuccessCount, setUploadSuccessCount] = useState(0);

  // State & City Management View State
  const [managementState, setManagementState] = useState(null); // Selected State ID
  const [managementCities, setManagementCities] = useState([]); // Cities for table
  const [managementCitySearch, setManagementCitySearch] = useState(""); // City Search Text
  const [cityModalVisible, setCityModalVisible] = useState(false);
  const [cityModalMode, setCityModalMode] = useState("add"); // "add" | "edit"
  const [editingCity, setEditingCity] = useState(null); // The city object being edited
  const [managementLoading, setManagementLoading] = useState(false);


  const handleCollapseToggle = (index) => {
    setCollapsedZones((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the collapsed state for this specific index
    }));
  };

  const [form] = Form.useForm();
  const activeTabRef = useRef(activeTab);

  /* eslint-disable indent */
  const getBusinessLine = (key) => {
    switch (key) {
      case "1":
        return "ecomm";
      case "2":
        return "courier";
      case "3":
        return "hyperlocal";
      case "4":
        return "metadata";
      case "5":
        return "mcn";
      default:
        return "ecomm";
    }
  };

  /* eslint-disable indent */
  const fetchData = async (page = 1, limit = 20, tabKey = "1", search = searchText, activeStatus = isActiveToggle, currentFilters = filters) => {
    setLoading(true);
    setDataSource([]); // Clear data to avoid column mismatch during loading
    try {
      const businessLine = getBusinessLine(tabKey);
      let response;

      // If "Pincode metadata" tab (key="4") or "MCN list" tab (key="5") is selected
      if (tabKey === "4" || tabKey === "5") {
        const params = {
          page,
          limit,
          search,
        };
        if (tabKey === "5") {
          params.mcn = true;
        }
        response = await PincodeService.getPincodeAreas({...params, ...currentFilters});
      } else {
        response = await PincodeService.getPincodeServiceability({
          page,
          limit,
          business_line: businessLine,
          search,
          ...(activeStatus ? { is_active: true } : {}),
          ...currentFilters
        });
      }

      if (tabKey !== activeTabRef.current) return; // Race condition check

      setDataSource(response.data || []);
      setPagination({
        current: Number(response.page),
        pageSize: Number(response.limit),
        total: Number(response.total),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch data");
    } finally {
      if (tabKey === activeTabRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    // Check if tab has really changed to trigger reset
    if (activeTabRef.current !== activeTab) {
      setFilters({}); // Reset local state
      // Fetch with empty filters immediately
      if (activeTab === "1" || activeTab === "2" || activeTab === "4" || activeTab === "5") {
        fetchData(1, 20, activeTab, searchText, isActiveToggle, {});
      } else if (activeTab === "6") {
        if (stateList.length === 0) {
          fetchStates();
        }
      }
    } else {
      // Just filter or toggle change in same tab
      if (activeTab === "1" || activeTab === "2" || activeTab === "4" || activeTab === "5") {
        fetchData(1, 20, activeTab, searchText, isActiveToggle, filters);
      }
    }
    
    activeTabRef.current = activeTab;
    cancelEdit();
    
    if (activeTab === "3") {
      fetchHyperlocalStates();
    }
    if (activeTab === "4" || activeTab === "5") {
      fetchHubs();
    }
  }, [activeTab, isActiveToggle, filters]);

  // Fetch states for filters on mount or tab change
  useEffect(() => {
    if (stateList.length === 0 && (activeTab === "1" || activeTab === "2" || activeTab === "4" || activeTab === "5" || activeTab === "6")) {
      fetchStates();
    }
  }, [activeTab]);

  const fetchStates = async () => {
    try {
      const states = await PincodeService.getServiceabilityStates();
      setStateList(states);
    } catch (error) {
      console.error("Failed to fetch states", error);
    }
  };

  const fetchHyperlocalStates = async () => {
    try {
      const states = await PincodeService.getHyperlocalStates();
      setHyperlocalStateList(states);
    } catch (error) {
      console.error("Failed to fetch hyperlocal states", error);
    }
  };

  const fetchFilterCities = async (stateId) => {
    try {
      const cities = await PincodeService.getServiceabilityCities(stateId);
      setCityFilterList(cities);
    } catch (error) {
      console.error("Failed to fetch filter cities", error);
      setCityFilterList([]);
    }
  };

  const fetchHubs = async () => {
    try {
      const hubs = await getHubList();
      setHubList(hubs);
    } catch (error) {
      console.error("Failed to fetch hubs", error);
    }
  };

  const handleStateChange = async (value) => {
    setHyperlocalState(value);
    setHyperlocalCity(null);
    setCityList([]);
    try {
      const cities = await PincodeService.getCities(value);
      setCityList(Array.isArray(cities) ? cities : []);
    } catch (error) {
      console.error("Failed to fetch cities", error);
    }
  };

  const handleCityChange = async (value) => {
    setHyperlocalCity(value);
    setZoneList([]);
    setLoading(true);
    try {
      // Extract city name if value is an object (though value should be the selected option's value which is label)
      // options={cityList.map(c => ... value: label })} so value is string.
      const cityName = typeof value === "object" ? (value?.city || value.cityName || value.name || value) : value;

      const zones = await PincodeService.getHyperlocalZones(cityName);
      console.log("Fetched Zones:", zones);
      setZoneList(Array.isArray(zones) ? zones : []);
    } catch (error) {
      console.error("Failed to fetch zones", error);
      setZoneList([]);
    } finally {
      setLoading(false);
    }
  };

  const clearHyperlocalFilters = () => {
    setHyperlocalState(null);
    setHyperlocalCity(null);
    setCityList([]);
    setZoneList([]);
  };

  const handleZoneToggle = async (zone, checked) => {
    try {
      setLoading(true);
      const zoneId = parseInt(zone._id || zone.id, 10);
      const payload = {
        data: {
          id: zoneId,
          isActive: checked
        }
      };
      await PincodeService.updateHyperlocalZone(payload);
      message.success(`Zone ${checked ? "activated" : "deactivated"} successfully`);
      // Refresh the list
      if (hyperlocalCity) {
        handleCityChange(hyperlocalCity);
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to update zone status");
      setLoading(false);
    }
  };



  // --- Create Zone Logic ---

  const openCreateModal = async () => {
    if (!hyperlocalCity) {
      message.warning("Please select a City first");
      return;
    }

    setCreateModalVisible(true);
    setFormattedLoading(true);
    setAvailablePincodes([]);
    setSelectedPincodes([]);
    setNewZoneName("");
    setPincodeSearch("");

    try {
      const cityName =
        typeof hyperlocalCity === "object"
          ? hyperlocalCity?.city || hyperlocalCity?.cityName || hyperlocalCity?.name
          : hyperlocalCity;

      const list = await PincodeService.getHyperlocalPincodeAreaMaster(
        hyperlocalState,
        cityName
      );

      setAvailablePincodes(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch hyperlocal pincode master");
    } finally {
      setFormattedLoading(false);
    }
  };


  const togglePincodeSelection = (pinObj) => {
    const isSelected = selectedPincodes.some(p => p.pincode === pinObj.pincode);
    if (isSelected) {
      setSelectedPincodes(selectedPincodes.filter(p => p.pincode !== pinObj.pincode));
    } else {
      setSelectedPincodes([...selectedPincodes, pinObj]);
    }
  };

  const handleCreateZoneSubmit = async () => {
    if (!newZoneName) {
      message.error("Please enter a Zone Name");
      return;
    }
    if (selectedPincodes.length === 0) {
      message.error("Please select at least one pincode");
      return;
    }

    setLoading(true);
    try {
      const cityName = typeof hyperlocalCity === "object" ? (hyperlocalCity?.city || hyperlocalCity.cityName || hyperlocalCity.name || hyperlocalCity) : hyperlocalCity;
      /*const payload = {
        zoneName: newZoneName,
        city: cityName,
        state: hyperlocalState, // Assuming state is selected
        pincodes: selectedPincodes.map(p => ({
          pincode: p.pincode,
          area: p.area || p.localities || [] // mapping available data
        })),
        isActive: true
      };*/

      const payload = {
        data: {
          name: newZoneName,
          city: cityName,
          state: hyperlocalState,
          serviceablePincodes: selectedPincodes.map(p => ({
            pincode: p.pincode,
            area: p.area || p.localities || [] // mapping available data
          })),
          isActive: true,
          orderProcessType: "NORMAL",
          acceptNormalOrder: false,
          acceptSubscriptionOrder: false
        },
        uniqueFieldName: "name"
      };
      // await PincodeService.createHyperlocalZone(payload);
      // 👉 2️⃣ SECOND CALL: Delcaper zone creation
      console.log("city....." + cityName);
      await PincodeService.createDelcaperZone(cityName, payload);
      message.success("Zone created successfully");
      setCreateModalVisible(false);
      handleCityChange(hyperlocalCity); // Refresh list
    } catch (err) {
      console.error(err);
      message.error(err.message || "Failed to create zone");
    } finally {
      setLoading(false);
    }
  };


  const filteredAvailablePincodes = availablePincodes.filter(pin =>
    pin.pincode.toString().includes(pincodeSearch) ||
    (pin.areaName && pin.areaName.toLowerCase().includes(pincodeSearch.toLowerCase())) ||
    (Array.isArray(pin.area) && pin.area.some(a => a.toLowerCase().includes(pincodeSearch.toLowerCase())))
  );

  const getMergedEditPincodes = () => {
    const byPin = new Map();
    editAvailablePincodes.forEach((p) => byPin.set(String(p.pincode), p));
    editSelectedPincodes.forEach((p) => {
      if (!byPin.has(String(p.pincode))) {
        byPin.set(String(p.pincode), { pincode: p.pincode, area: p.area || [] });
      }
    });
    return Array.from(byPin.values());
  };

  const filteredEditAvailablePincodes = getMergedEditPincodes().filter(
    (pin) =>
      pin.pincode.toString().includes(editPincodeSearch) ||
      (pin.areaName && pin.areaName.toLowerCase().includes(editPincodeSearch.toLowerCase())) ||
      (Array.isArray(pin.area) &&
        pin.area.some((a) => a.toLowerCase().includes(editPincodeSearch.toLowerCase())))
  );

  const openEditZoneModal = async (zone) => {
    if (!hyperlocalCity || !hyperlocalState) {
      message.warning("Please select State and City first");
      return;
    }

    setEditingZone(zone);
    setEditZoneName(zone?.name || zone?.zoneName || "");
    setEditOrderProcessType(zone?.orderProcessType || zone?.processType || "NORMAL");
    setEditAcceptNormalOrder(!!zone?.acceptNormalOrder);
    setEditAcceptSubscriptionOrder(!!zone?.acceptSubscriptionOrder);
    setEditSelectedPincodes(
      (zone?.serviceablePincodes || zone?.pincodes || []).map((p) => ({
        pincode: typeof p === "object" ? p.pincode : p,
        area: typeof p === "object" ? (p.area || p.localities || []) : [],
      }))
    );
    setEditPincodeSearch("");
    setEditZoneModalVisible(true);
    setEditZoneLoading(true);

    try {
      const cityName =
        typeof hyperlocalCity === "object"
          ? hyperlocalCity?.city || hyperlocalCity?.cityName || hyperlocalCity?.name
          : hyperlocalCity;
      const list = await PincodeService.getHyperlocalPincodeAreaMaster(
        hyperlocalState,
        cityName
      );
      setEditAvailablePincodes(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch pincode area master");
    } finally {
      setEditZoneLoading(false);
    }
  };

  const toggleEditPincodeSelection = (pinObj) => {
    const isSelected = editSelectedPincodes.some((p) => p.pincode === pinObj.pincode);
    if (isSelected) {
      setEditSelectedPincodes(editSelectedPincodes.filter((p) => p.pincode !== pinObj.pincode));
    } else {
      setEditSelectedPincodes([
        ...editSelectedPincodes,
        { pincode: pinObj.pincode, area: pinObj.area || pinObj.localities || [] },
      ]);
    }
  };

  const handleEditZoneSubmit = async () => {
    if (!editZoneName?.trim()) {
      message.error("Please enter a zone name");
      return;
    }
    if (editSelectedPincodes.length === 0) {
      message.error("Please select at least one pincode");
      return;
    }

    setLoading(true);
    try {
      const cityName =
        typeof hyperlocalCity === "object"
          ? hyperlocalCity?.city || hyperlocalCity.cityName || hyperlocalCity.name || hyperlocalCity
          : hyperlocalCity;
      const zoneId = parseInt(editingZone?._id || editingZone?.id, 10);

      const payload = {
        data: {
          id: zoneId,
          name: editZoneName.trim(),
          city: cityName,
          state: hyperlocalState,
          serviceablePincodes: editSelectedPincodes.map((p) => ({
            pincode: String(p.pincode),
            area: p.area || [],
          })),
          orderProcessType: editOrderProcessType,
          acceptNormalOrder: editAcceptNormalOrder,
          acceptSubscriptionOrder: editAcceptSubscriptionOrder,
        },
      };

      await PincodeService.updateHyperlocalZone(payload);
      message.success("Zone updated successfully");
      setEditZoneModalVisible(false);
      setEditingZone(null);
      if (hyperlocalCity) {
        handleCityChange(hyperlocalCity);
      }
    } catch (err) {
      console.error(err);
      message.error(err.message || "Failed to update zone");
    } finally {
      setLoading(false);
    }
  };

  const handleManualMetadataStateChange = async (stateId) => {
    form.setFieldsValue({ city: undefined });
    setManualMetadataCities([]);
    if (!stateId) return;
    try {
      const cities = await PincodeService.getServiceabilityCities(stateId);
      setManualMetadataCities(Array.isArray(cities) ? cities : []);
    } catch (error) {
      console.error("Failed to fetch cities for manual metadata", error);
      message.error("Failed to load cities");
    }
  };

  const supportsManualEntry = activeTab === "1" || activeTab === "2" || activeTab === "4";

  // Manage Zone Modal Handlers
  const openManageZoneModal = async () => {
    setManageZoneModalVisible(true);
    setManageZoneTableData([]);
    setManageZoneTotal(0);
    setManageZonePage(1);

    setBulkEcommZone(null);
    setBulkCourierZone(null);
    setBulkEcommBillingZone(null);
    setBulkCourierBillingZone(null);
    setBulkPincodeText("");
    setBulkPincodeList([]);

    // Reset selection
    setManageZoneSearchText("");

    setManageZoneLoading(true);
    fetchDropdownLists();
    fetchManageZoneData(1);
  };

  const fetchDropdownLists = async () => {
    try {
      setManageZoneLoading(true);
      const [ecommZones, courierZones, ecommBilling, courierBilling] = await Promise.all([
        PincodeService.getZones("ecomm"),
        PincodeService.getZones("courier"),
        PincodeService.getBillingZones("ecomm"),
        PincodeService.getBillingZones("courier"),
      ]);

      if (Array.isArray(ecommZones)) setEcommZoneList(ecommZones);
      if (Array.isArray(courierZones)) setCourierZoneList(courierZones);
      if (Array.isArray(ecommBilling)) setEcommBillingZoneList(ecommBilling);
      if (Array.isArray(courierBilling)) setCourierBillingZoneList(courierBilling);
    } catch (error) {
      console.error("Failed to fetch data:", error);
      message.error("Failed to fetch data");
    } finally {
      setLoading(false);
      setManageZoneLoading(false);
    }
  };

  const handleOpenCreateEntity = (type) => {
    setEntityType(type);
    setNewEntityName("");
    setNewEntityBusinessLine("ecomm");
    setCreateEntityModalVisible(true);
  };

  const handleCreateEntity = async () => {
    if (!newEntityName) {
      message.error("Please enter a name");
      return;
    }
    setManageZoneLoading(true);
    try {
      const payload = {
        business_line: newEntityBusinessLine,
        name: newEntityName,
      };

      if (entityType === "zone") {
        await PincodeService.createZone(payload);
        message.success("Zone created successfully");
      } else {
        await PincodeService.createBillingZone(payload);
        message.success("Billing Zone created successfully");
      }

      setCreateEntityModalVisible(false);
      fetchDropdownLists();
    } catch (error) {
      console.error("Failed to create entity:", error);
      message.error("Failed to create entity");
      setManageZoneLoading(false);
    }
  };

  // Handler to add pincodes from input text
  const handleAddPincodes = () => {
    if (!bulkPincodeText.trim()) return;

    const inputPincodes = bulkPincodeText
      .split(/[,\s]+/) // Split by comma or whitespace
      .map(p => p.trim())
      .filter(p => p); // Remove empty strings

    const validPincodes = [];
    const invalidPincodes = [];

    inputPincodes.forEach(pincode => {
      if (/^\d{6}$/.test(pincode)) {
        // Valid 6-digit pincode
        if (!bulkPincodeList.includes(pincode)) {
          validPincodes.push(pincode);
        }
      } else {
        invalidPincodes.push(pincode);
      }
    });

    if (invalidPincodes.length > 0) {
      message.warning(`Invalid pincodes (must be 6 digits): ${invalidPincodes.join(", ")}`);
    }

    if (validPincodes.length > 0) {
      setBulkPincodeList([...bulkPincodeList, ...validPincodes]);
      setBulkPincodeText("");
    }
  };

  // Handler for input key press
  const handlePincodeInputKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddPincodes();
    }
  };

  // Handler to remove a pincode tag
  const handleRemoveBulkPincode = (pincode) => {
    setBulkPincodeList(bulkPincodeList.filter(p => p !== pincode));
  };

  const handleBulkUpdate = async () => {
    // Validate at least one zone is selected
    if (!bulkEcommZone && !bulkCourierZone && !bulkEcommBillingZone && !bulkCourierBillingZone) {
      message.warning("Please select at least one zone to update.");
      return;
    }

    Modal.confirm({
      title: "Confirm Bulk Update",
      content: "Are you sure you want to update the entered pincodes with the chosen zones?",
      onOk: async () => {
        setManageZoneLoading(true);
        try {
          // Use only bulk pincode list
          const allTargetPincodes = [...bulkPincodeList];

          if (allTargetPincodes.length === 0) {
            message.warning("Please enter pincodes in the input field above.");
            setManageZoneLoading(false);
            return;
          }

          const getValidId = (val) => {
            const num = Number(val);
            return (!isNaN(num) && num > 0) ? num : null;
          };

          const payload = {
            pincodes: allTargetPincodes.map(p => Number(p)),
            ...(getValidId(bulkEcommZone) ? { ecomm_zone_id: getValidId(bulkEcommZone) } : {}),
            ...(getValidId(bulkCourierZone) ? { courier_zone_id: getValidId(bulkCourierZone) } : {}),
            ...(getValidId(bulkEcommBillingZone) ? { ecomm_billing_zone_id: getValidId(bulkEcommBillingZone) } : {}),
            ...(getValidId(bulkCourierBillingZone) ? { courier_billing_zone_id: getValidId(bulkCourierBillingZone) } : {})
          };

          // If payload object has no zones (keys length only 1 for 'pincodes'), warn user
          if (Object.keys(payload).length <= 1) {
            message.warning("Please select at least one zone to update.");
            setManageZoneLoading(false);
            return;
          }

          const response = await PincodeService.bulkUpdateZones(payload);

          // Debug logging
          console.log("Bulk update response:", response);

          // Handle response with success and failed pincodes
          // Check if response is nested under 'data' property
          const responseData = response?.data || response;
          const successCount = responseData?.successCount || 0;
          const failedPincodes = responseData?.failedPincodes || [];

          console.log("=== BULK UPDATE RESPONSE DEBUG ===");
          console.log("Full response:", response);
          console.log("Response data:", responseData);
          console.log("Success count:", successCount);
          console.log("Failed pincodes:", failedPincodes);
          console.log("Failed pincodes length:", failedPincodes.length);
          console.log("==================================");

          if (failedPincodes.length > 0) {
            // Some pincodes failed - show dedicated modal
            console.log("Showing failed pincodes modal...");
            setFailedPincodesData({ successCount, failedPincodes });
            setFailedPincodesModalVisible(true);
          } else if (successCount > 0) {
            // All successful
            message.success(`Successfully updated ${successCount} pincode(s).`);
          } else {
            // No updates happened
            message.warning("No pincodes were updated. Please check the response.");
          }

          if (manageZoneSearchText) {
            fetchManageZoneData(manageZonePage); // Refresh if viewing search results
          }

          setBulkEcommZone(null);
          setBulkCourierZone(null);
          setBulkEcommBillingZone(null);
          setBulkCourierBillingZone(null);
          setBulkPincodeText("");
          setBulkPincodeList([]);
        } catch (error) {
          console.error("Bulk update failed", error);
          message.error(error?.message || "Bulk update failed");
        } finally {
          setManageZoneLoading(false);
        }
      },
    });
  };






  const fetchManageZoneData = async (page = 1, search = manageZoneSearchText) => {
    setManageZoneLoading(true);

    try {
      const params = {
        page,
        limit: 10,
      };
      if (search) params.search = search;

      const response = await PincodeService.getPincodeAreas(params);
      setManageZoneTableData(response.data || []);
      setManageZoneTotal(response.total || 0);
      setManageZonePage(page);
    } catch (error) {
      console.error("Failed to fetch zone data", error);
      message.error("Failed to fetch zone data");
    } finally {
      setManageZoneLoading(false);
    }
  };



  const handleServiceToggle = async (record, service) => {
    console.log("handleServiceToggle called", { record, service, editingKey });
    if (typeof service !== "object") {
      console.log("Service is not an object", service);
      return;
    }

    // Check for id or service_id
    const serviceId = service.id || service.service_id;

    if (!serviceId) {
      console.log("Service ID missing", service);
      return;
    }

    try {
      setLoading(true);
      await PincodeService.toggleService([{ pincode: record.pincode, service_id: serviceId }]);
      message.success(`Service ${service.name} toggled successfully`);
      fetchData(pagination.current, pagination.pageSize, activeTab);
    } catch (error) {
      console.error(error);
      message.error("Failed to toggle service");
      setLoading(false);
    }
  };

  const handleTogglePincodeActive = async (record, checked) => {
    try {
      setLoading(true);
      const payload = {
        pincodes: [record.pincode],
        isActive: checked,
        businessLine: getBusinessLine(activeTab),
      };
      await PincodeService.togglePincodeActive(payload);
      message.success(`Pincode ${record.pincode} ${checked ? "activated" : "deactivated"} successfully`);
      // Update local state to avoid full refresh if preferred,
      // but fetchData ensures consistency with total counts.
      fetchData(pagination.current, pagination.pageSize, activeTab);
    } catch (error) {
      console.error("Failed to toggle pincode active status:", error);
      message.error(error.message || "Failed to toggle status");
      setLoading(false);
    }
  };

  const getSingleFilterValue = (newFilters, key) => {
    const value = newFilters?.[key];
    return Array.isArray(value) && value.length > 0 ? value[0] : undefined;
  };

  const handleTableChange = (newPagination, newFilters) => {
    
    console.log("handleTableChange NEW FILTERS:", newFilters);
    console.log("handleTableChange CURRENT FILTERS:", filters);

    const updatedFilters = { ...filters };
    const textFilterKeys = [
      "pincode",
      "zone",
      "hub_name",
      "ecomm_zone",
      "courier_zone",
      "ecomm_billing_zone",
      "courier_billing_zone",
    ];

    textFilterKeys.forEach((key) => {
      const value = getSingleFilterValue(newFilters, key);
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        updatedFilters[key] = String(value).trim();
      } else {
        delete updatedFilters[key];
      }
    });

    const activeFilter = getSingleFilterValue(newFilters, "is_active");
    if (activeFilter !== undefined && activeFilter !== null) {
      updatedFilters.is_active = activeFilter === true || activeFilter === "true";
    } else {
      delete updatedFilters.is_active;
    }

    if (newFilters.state && newFilters.state.length > 0) {
      updatedFilters.state = newFilters.state[0];
    } else {
      // If state is cleared, also clear city and local state tracking
      delete updatedFilters.state;
      delete updatedFilters.city;
      setSelectedStateForFilter(null);
      setCityFilterList([]);
    }

    if (newFilters.city && newFilters.city.length > 0) {
      // Only apply city filter if state is selected
      if (updatedFilters.state) {
        updatedFilters.city = newFilters.city[0];
      } else {
         delete updatedFilters.city;
      }
    } else {
      delete updatedFilters.city;
    }

    setFilters(updatedFilters);
    fetchData(newPagination.current, newPagination.pageSize, activeTab, searchText, isActiveToggle, updatedFilters);
  };



  // Custom props for State Filter Dropdown
  const getStateColumnProps = () => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div style={{ padding: 8, width: 250 }}>
        <Select
          showSearch
          placeholder="Select State"
          value={selectedKeys[0]}
          onChange={(value, option) => {
            // value is state name, option has key/id
            setSelectedKeys(value ? [value] : []);
            const stateId = option?.key;
            const stateName = value;

            console.log("State Selected for Filter:", stateName, stateId);

            // Update local state for dependency
            if (stateId) {
              setSelectedStateForFilter({ id: stateId, name: stateName });
              fetchFilterCities(stateId);
            } else {
              setSelectedStateForFilter(null);
              setCityFilterList([]);
            }
            
            // Clear Dependent City Filter if State Changes
            const updatedFilters = { ...filters, state: stateName };
            delete updatedFilters.city;
            setFilters(updatedFilters);
            
            // Confirm immediately
            confirm();
          }}
          style={{ width: "100%", marginBottom: 8, display: "block" }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {stateList.map((state) => (
            <Option key={state.id} value={state.name}>
              {state.name}
            </Option>
          ))}
        </Select>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              setSelectedStateForFilter(null);
              setCityFilterList([]);
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: () => true,
  });

  // Custom props for City Filter Dropdown (Dependent)
  const getCityColumnProps = () => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div style={{ padding: 8, width: 250 }}>
        <Select
          showSearch
          placeholder={selectedStateForFilter ? "Select City" : "Select State First"}
          value={selectedKeys[0]}
          onChange={(value) => {
            setSelectedKeys(value ? [value] : []);
            confirm();
          }}
          disabled={!selectedStateForFilter}
          style={{ width: "100%", marginBottom: 8, display: "block" }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {cityFilterList.map((city) => (
            <Option key={city.id} value={city.name}>
              {city.name}
            </Option>
          ))}
        </Select>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: () => true,
  });

  const getTextColumnSearchProps = (columnKey, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8, width: 220 }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
          allowClear
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.();
              setSelectedKeys([]);
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filteredValue:
      filters[columnKey] !== undefined && filters[columnKey] !== null && filters[columnKey] !== ""
        ? [filters[columnKey]]
        : null,
    onFilter: () => true,
  });

  const getActiveStatusColumnProps = () => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8, width: 180 }}>
        <Select
          placeholder="Select Status"
          value={selectedKeys[0]}
          onChange={(value) => setSelectedKeys(value ? [value] : [])}
          style={{ width: "100%", marginBottom: 8, display: "block" }}
          allowClear
        >
          <Option value="true">Active</Option>
          <Option value="false">Inactive</Option>
        </Select>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 80 }}
          >
            Apply
          </Button>
          <Button
            onClick={() => {
              clearFilters?.();
              setSelectedKeys([]);
              confirm();
            }}
            size="small"
            style={{ width: 80 }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filteredValue:
      filters.is_active !== undefined && filters.is_active !== null
        ? [String(filters.is_active)]
        : null,
    filterMultiple: false,
    onFilter: () => true,
  });

  const handleHubUpdate = async (record, hub) => {
    try {
      setLoading(true);

      const updateData = {
        tat_in_hours: String(record.tat_in_hours),
        hubName: hub?.label,
        hubCode: hub?.value
      };

      const payload = {
        pincode: record.pincode,
        update: updateData
      };

      if (activeTab === "5") {
        payload.mcn_update = true;
      }

      await PincodeService.updatePincodeArea(payload);
      message.success("Hub updated successfully");
      fetchData(pagination.current, pagination.pageSize, activeTab);
    } catch (error) {
      console.error("Failed to update hub:", error);
      message.error(error.message || "Failed to update hub");
    } finally {
      setLoading(false);
    }
  };

  const courierColumns = [
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      width: 120,
      ...getTextColumnSearchProps("pincode", "Search Pincode"),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
      ...getStateColumnProps(),
      filterMultiple: false,
      filteredValue: filters.state ? [filters.state] : null,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      ...getCityColumnProps(),
      filteredValue: filters.city ? [filters.city] : null,
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
    },
    {
      title: "Zone",
      dataIndex: "zone",
      key: "zone",
      ...getTextColumnSearchProps("zone", "Search Zone"),
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
    },
    {
      title: "Hub Name",
      dataIndex: "hub_name",
      key: "hub_name",
      ...getTextColumnSearchProps("hub_name", "Search Hub Name"),
      render: (text) =>
        (typeof text === "object" && text !== null ? text.name : text) || "---",
    },
    /*{
      title: "District IP",
      dataIndex: "district_ip",
      key: "district_ip",
      render: (text) =>
        (typeof text === "object" && text !== null ? text.name : text) || "---",
    },*/
    /*{
      title: "State Code",
      dataIndex: "state_code",
      key: "state_code",
      render: (text) =>
        (typeof text === "object" && text !== null ? text.name : text) || "---",
    },*/
    /*{
      title: "Pincode Type",
      dataIndex: "pincode_type",
      key: "pincode_type",
      render: (text) =>
        (typeof text === "object" && text !== null ? text.name : text) || "---",
    },*/
    /* {
       title: (
         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
           Serviceability Type {filterIcon}
         </div>
       ),
       dataIndex: "serviceability_type",
       key: "serviceability_type",
       render: (text) =>
         (typeof text === "object" && text !== null ? text.name : text) || "---",
     },*/
    {
      title: "Services",
      key: "services",
      render: (_, record) => {
        // Construct services list from boolean flags if present
        const services = [];
        if (record.cod) services.push("COD");
        if (record.prepaid) services.push("PREPAID");
        if (record.reverse_pickup) services.push("RVP");

        // Use constructed services or fallback to record.services if array
        const displayServices = Array.isArray(record.services)
          ? record.services
          : services;

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {displayServices.length > 0
              ? displayServices.map((service) => (
                <Tag
                  key={typeof service === "object" ? service.id : service}
                  color={
                    typeof service === "object" && service.is_active === false
                      ? "red"
                      : "green"
                  }
                  style={{
                    borderRadius: "12px",
                    cursor: (editingKey === record.pincode && hasWriteAccess) ? "pointer" : "default",
                  }}
                  onClick={() => {
                    console.log("Tag clicked (Courier)", { editingKey, recordPincode: record.pincode, service });
                    if (editingKey === record.pincode && hasWriteAccess) {
                      handleServiceToggle(record, service);
                    }
                  }}
                >
                  {typeof service === "object" ? service.name : service}
                </Tag>
              ))
              : "---"}
          </div>
        );
      },
    },
    {
      title: "Active / Inactive",
      dataIndex: "is_active",
      key: "is_active",
      ...getActiveStatusColumnProps(),
      render: (active, record) => (
        <Switch
          checked={active}
          disabled={editingKey !== record.pincode || !hasWriteAccess} // Read-only
          onChange={(checked) => handleTogglePincodeActive(record, checked)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        if (!hasWriteAccess) return null;
        return (
          <Button
            type="link"
            icon={editingKey === record.pincode ? <CloseCircleOutlined /> : <EditOutlined />}
            onClick={() => handleEdit(record)}
          />
        );
      },
    },
  ];



  const metadataColumns = [
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      width: "25%",
      ...getTextColumnSearchProps("pincode", "Search Pincode"),
    },
    {
      title: activeTab === "5" ? "3PL Hub Name" : "Hub Name",
      dataIndex: "hub_name",
      key: "hub_name",
      width: "25%",
      ...getTextColumnSearchProps(
        "hub_name",
        activeTab === "5" ? "Search 3PL Hub Name" : "Search Hub Name"
      ),
      render: (text, record) => {
        const isEditing = editingKey === record.pincode;
        const currentHubId = (typeof text === "object" && text !== null ? text.id : text) || null;

        // Show dropdown if editing OR if hub name is not available
        if (isEditing) {
          return (
            <Select
              showSearch
              labelInValue
              value={isEditing ? editingHub : (currentHubId ? { value: currentHubId, label: (typeof text === "object" ? text.name : text) } : undefined)}
              onChange={async (value) => {
                if (isEditing) {
                  setEditingHub(value);
                } else {
                  handleHubUpdate(record, value);
                }
              }}
              style={{ width: "100%" }}
              placeholder="Select Hub"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {hubList.map((hub) => (
                <Option key={hub.value} value={hub.value}>
                  {hub.label}
                </Option>
              ))}
            </Select>
          );
        }
        return (typeof text === "object" && text !== null ? text.name : text) || "---";
      },
    },

    {
      title: "State",
      dataIndex: "state",
      key: "state",
      align: "center",
      width: "25%",
      render: (text) => (text !== undefined && text !== null ? text : "---"),
      ...getStateColumnProps(),
      filterMultiple: false,
      filteredValue: filters.state ? [filters.state] : null,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      align: "center",
      width: "25%",
      ...getCityColumnProps(),
      filteredValue: filters.city ? [filters.city] : null,
      render: (text) => (text !== undefined && text !== null ? text : "---"),
    },
    {
      title: "Ecomm Zone",
      dataIndex: "ecomm_zone",
      key: "ecomm_zone",
      align: "center",
      width: "25%",
      ...getTextColumnSearchProps("ecomm_zone", "Search Ecomm Zone"),
      render: (text) => (text !== undefined && text !== null ? text : "---"),
    },
    {
      title: "Courier Zone",
      dataIndex: "courier_zone",
      key: "courier_zone",
      align: "center",
      width: "25%",
      ...getTextColumnSearchProps("courier_zone", "Search Courier Zone"),
      render: (text) => (text !== undefined && text !== null ? text : "---"),
    },
    {
      title: "Ecomm Billing Zone",
      dataIndex: "ecomm_billing_zone",
      key: "ecomm_billing_zone",
      align: "center",
      width: "25%",
      ...getTextColumnSearchProps("ecomm_billing_zone", "Search Ecomm Billing Zone"),
      render: (text) => (text !== undefined && text !== null ? text : "---"),
    },
    {
      title: "Courier Billing Zone",
      dataIndex: "courier_billing_zone",
      key: "courier_billing_zone",
      align: "center",
      width: "25%",
      ...getTextColumnSearchProps("courier_billing_zone", "Search Courier Billing Zone"),
      render: (text) => (text !== undefined && text !== null ? text : "---"),
    },
    {
      title: "Transit Hours for Delivery",
      dataIndex: "tat_in_hours",
      key: "tat_in_hours",
      align: "center",
      width: "25%",
      render: (text, record) => {
        if (editingKey === record.pincode && hasWriteAccess) {
          return (
            <Input
              value={editingTransitDays}
              onChange={(e) => setEditingTransitDays(e.target.value)}
              style={{ width: "80px", textAlign: "center" }}
            />
          );
        }
        return text !== undefined && text !== null ? text : "---";
      },
    },
    {
      title: "Transit Hours for Pickup",
      dataIndex: "pickup_tat_in_hours",
      key: "pickup_tat_in_hours",
      align: "center",
      width: "25%",
      render: (text, record) => {
        if (editingKey === record.pincode && hasWriteAccess) {
          return (
            <Input
              value={editingPickupHours}
              onChange={(e) => setEditingPickupHours(e.target.value)}
              style={{ width: "80px", textAlign: "center" }}
            />
          );
        }
        return text !== undefined && text !== null ? text : "---";
      },
    },
    {
      title: "Action",
      key: "action",
      width: "25%",
      render: (_, record) => {
        if (!hasWriteAccess) return null;
        const editable = editingKey === record.pincode;
        return editable ? (
          <span>
            <Button
              type="link"
              icon={<CheckOutlined />}
              onClick={() => saveTransitDays(record)}
              style={{ marginRight: 8, color: "green" }}
            />
            <Button
              type="link"
              icon={<CloseOutlined />}
              onClick={cancelEdit}
              style={{ color: "red" }}
            />
          </span>
        ) : (
          <Button
            type="link"
            icon={<EditOutlined />}
            disabled={editingKey !== ""}
            onClick={() => handleEdit(record)}
          />
        );
      },
    },
  ];



  const ecommColumns = [
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      width: 120,
      ...getTextColumnSearchProps("pincode", "Search Pincode"),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
      ...getStateColumnProps(),
      filterMultiple: false,
      filteredValue: filters.state ? [filters.state] : null,
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      ...getCityColumnProps(),
      filteredValue: filters.city ? [filters.city] : null,
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
    },
    {
      title: "Zone",
      dataIndex: "zone",
      key: "zone",
      ...getTextColumnSearchProps("zone", "Search Zone"),
      render: (text) =>
        typeof text === "object" && text !== null ? text.name : text,
    },
    {
      title: "Hub Name",
      dataIndex: "hub_name",
      key: "hub_name",
      ...getTextColumnSearchProps("hub_name", "Search Hub Name"),
      render: (text) =>
        (typeof text === "object" && text !== null ? text.name : text) || "---",
    },
    {
      title: "Services",
      key: "services",
      render: (_, record) => {
        // Construct services list from boolean flags if present
        const services = [];
        if (record.cod) services.push("COD");
        if (record.prepaid) services.push("PREPAID");
        if (record.reverse_pickup) services.push("RVP");

        // Use constructed services or fallback to record.services if array
        const displayServices = Array.isArray(record.services)
          ? record.services
          : services;

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {displayServices.length > 0
              ? displayServices.map((service) => (
                <Tag
                  key={typeof service === "object" ? service.id : service}
                  color={
                    typeof service === "object" && service.is_active === false
                      ? "red"
                      : "green"
                  }
                  style={{
                    borderRadius: "12px",
                    cursor: (editingKey === record.pincode && hasWriteAccess) ? "pointer" : "default",
                  }}
                  onClick={() => {
                    console.log("Tag clicked (Ecomm)", { editingKey, recordPincode: record.pincode, service });
                    if (editingKey === record.pincode && hasWriteAccess) {
                      handleServiceToggle(record, service);
                    }
                  }}
                >
                  {typeof service === "object" ? service.name : service}
                </Tag>
              ))
              : "---"}
          </div>
        );
      },
    },
    {
      title: "Active / Inactive",
      dataIndex: "is_active",
      key: "is_active",
      ...getActiveStatusColumnProps(),
      render: (active, record) => (
        <Switch
          checked={active}
          disabled={editingKey !== record.pincode || !hasWriteAccess} // Read-only
          onChange={(checked) => handleTogglePincodeActive(record, checked)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        if (!hasWriteAccess) return null;
        return (
          <Button
            type="link"
            icon={editingKey === record.pincode ? <CloseCircleOutlined /> : <EditOutlined />}
            onClick={() => handleEdit(record)}
          />
        );
      },
    },
  ];

  const getColumns = () => {
    let cols = [];
    if (activeTab === "4") {
      cols = metadataColumns;
    } else if (activeTab === "5") {
      const excludedKeys = [
        "ecomm_zone",
        "courier_zone",
        "ecomm_billing_zone",
        "courier_billing_zone",
        "tat_in_hours",
        "pickup_tat_in_hours"
      ];
      cols = metadataColumns.filter(col => !excludedKeys.includes(col.key));
    } else if (activeTab === "2") {
      cols = courierColumns;
    } else {
      cols = ecommColumns;
    }

    if (!hasWriteAccess) {
      return cols.filter((col) => col.key !== "action");
    }
    return cols;
  };

  const columns = getColumns();




  const handleExport = async () => {
    try {
      setLoading(true);

      if (activeTab === "4" || activeTab === "5") {
        const exportType = activeTab === "5" ? "mcn" : "metadata";
        const response = await PincodeService.exportPincodeMetadata({
          search: searchText,
          ...(activeTab === "5" ? { mcn: true } : {}),
          ...filters,
        });
        if (response?.status && response?.response?.data) {
          const blob = new Blob([response.response.data], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `pincode_${exportType}_export_${new Date().toISOString().slice(0, 10)}.csv`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          message.success("Export successful");
        } else {
          message.warning("Export failed or no data returned");
        }
        return;
      }

      const businessLine = getBusinessLine(activeTab);
      const response = await PincodeService.exportPincodeServiceability({
        business_line: businessLine,
        search: searchText,
        ...(isActiveToggle ? { is_active: true } : {}),
        ...filters,
      });

      if (response?.status && response?.response?.data) {
        // Create a blob from the response data
        const blob = new Blob([response.response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `pincode_export_${businessLine}_${new Date().toISOString().slice(0, 10)}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        message.success("Export successful");
      } else {
        message.warning("Export failed or no data returned");
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to export data");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setModalMode("add");
    setAddEntryMode("bulk");
    form.resetFields();
    setUploadedFile(null);
    setManualMetadataCities([]);
    if (activeTab === "4") {
      fetchDropdownLists();
    }
    if (activeTab === "1" || activeTab === "2") {
      form.setFieldsValue({
        fm: true,
        lm: true,
        cod: false,
        sdd: false,
        ndd: false,
      });
    }
    setIsModalVisible(true);
  };





  const handleEdit = (record) => {
    // If already editing this row, cancel edit mode
    if (editingKey === record.pincode) {
      setEditingKey("");
      setEditingTransitDays(null);
      setEditingPickupHours(null);
      setEditingHub(null);
      return;
    }
    // Otherwise set edit mode for this row
    setEditingKey(record.pincode);
    setEditingTransitDays(record.tat_in_hours);
    setEditingPickupHours(record.pickup_tat_in_hours);
    // Determine hub: try record.hub_name.id and record.hub_name.name
    const currentHubId = (record.hub_name && typeof record.hub_name === "object" && record.hub_name.id) || record.hub_id || null;
    const currentHubName = (record.hub_name && typeof record.hub_name === "object" && record.hub_name.name) || (typeof record.hub_name === "string" ? record.hub_name : null);

    setEditingHub(currentHubId ? { value: currentHubId, label: currentHubName } : null);
  };

  const cancelEdit = () => {
    setEditingKey("");
    setEditingTransitDays(null);
    setEditingPickupHours(null);
    setEditingHub(null);
  };

  const saveTransitDays = async (record) => {
    try {
      setLoading(true);
      const updateData = {
        tat_in_hours: Number(editingTransitDays)
      };
      if (editingPickupHours !== null && editingPickupHours !== undefined && String(editingPickupHours).trim() !== "") {
        updateData.pickup_tat_in_hours = Number(editingPickupHours);
      }
      if (editingHub) {
        console.log("Editing hub:", editingHub);
        updateData.hubCode = editingHub.value;
        updateData.hubName = editingHub.label;
      }

      const payload = {
        pincode: record.pincode,
        update: updateData
      };

      if (activeTab === "5") {
        payload.mcn_update = true;
      }

      await PincodeService.updatePincodeArea(payload);
      message.success("Transit hours updated successfully");
      cancelEdit();
      fetchData(pagination.current, pagination.pageSize, activeTab);
    } catch (error) {
      console.error("Failed to update transit hours:", error);
      message.error(error.message || "Failed to update transit hours");
    } finally {
      setLoading(false);
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setUploadedFile(null);
    setAddEntryMode("bulk");
    setManualMetadataCities([]);
  };

  const handleModalOk = async () => {
    if (modalMode !== "add") {
      return;
    }

    if (supportsManualEntry && addEntryMode === "manual") {
      try {
        const values = await form.validateFields();
        setLoading(true);

        if (activeTab === "4") {
          const selectedState = stateList.find((s) => s.id === values.state_id);
          await PincodeService.createPincodeMetadata({
            pincode: Number(values.pincode),
            state: selectedState?.name || values.state,
            city: values.city,
            hub_name: values.hub_name,
            ecomm_zone: values.ecomm_zone,
            courier_zone: values.courier_zone,
            ecomm_billing_zone: values.ecomm_billing_zone,
            courier_billing_zone: values.courier_billing_zone,
            tat_in_hours: Number(values.tat_in_hours),
            ...(values.pickup_tat_in_hours != null && values.pickup_tat_in_hours !== ""
              ? { pickup_tat_in_hours: Number(values.pickup_tat_in_hours) }
              : {}),
          });
          message.success("Pincode metadata created successfully");
        } else {
          const business_line = getBusinessLine(activeTab);
          const services = {
            fm: !!values.fm,
            lm: !!values.lm,
          };
          if (activeTab === "1") {
            services.cod = !!values.cod;
            services.sdd = !!values.sdd;
            services.ndd = !!values.ndd;
          }
          await PincodeService.createPincode({
            pincode: Number(values.pincode),
            business_line,
            services,
          });
          message.success("Pincode serviceability created successfully");
        }

        setIsModalVisible(false);
        form.resetFields();
        setAddEntryMode("bulk");
        setManualMetadataCities([]);
        fetchData(1, pagination.pageSize, activeTab);
      } catch (error) {
        console.error(error);
        message.error(error.message || "Failed to create pincode");
      } finally {
        setLoading(false);
      }
      return;
    }

    if (!uploadedFile) {
      message.error("Please upload a file");
      return;
    }
    try {
      setLoading(true);
      const businessLine = getBusinessLine(activeTab);
      const response = await PincodeService.bulkUploadPincode(uploadedFile, businessLine);
      

      if (response?.success === false || response?.statusCode >= 400 || response?.error) {
        if (response?.failed_rows && response.failed_rows.length > 0) {
          setUploadErrorData(response.failed_rows);
          setUploadSuccessCount(response.inserted_count || 0);
          setUploadErrorModalVisible(true);
          setIsModalVisible(false);
          setUploadedFile(null);
        } else if (response?.message || response?.error) {
          let errorMessages = [];
          const msgSource = response.message || response.error;
          if (Array.isArray(msgSource)) {
            errorMessages = msgSource.map((msg) => ({ row: "-", error: msg }));
          } else {
            errorMessages = [{ row: "-", error: msgSource }];
          }
          setUploadErrorData(errorMessages);
          setUploadSuccessCount(response.inserted_count || 0);
          setUploadErrorModalVisible(true);
          setIsModalVisible(false);
          setUploadedFile(null);
        } else {
          message.error("Upload failed");
        }
      } else {
        message.success("File uploaded successfully");
        setIsModalVisible(false);
        setUploadedFile(null);
        fetchData(1, pagination.pageSize, activeTab);
      }
    } catch (error) {
      console.error("Upload failed", error);
      message.error("Failed to upload file");
    } finally {
      setLoading(false);
    }
  };

  const manageZoneColumns = [
    { title: "Pincode", dataIndex: "pincode", key: "pincode" },
    { title: "Ecomm Zone", dataIndex: "ecomm_zone", key: "ecomm_zone" },
    { title: "Courier Zone", dataIndex: "courier_zone", key: "courier_zone" },
    { title: "Ecomm Billing Zone", dataIndex: "ecomm_billing_zone", key: "ecomm_billing_zone" },
    { title: "Courier Billing Zone", dataIndex: "courier_billing_zone", key: "courier_billing_zone" },
  ];

  return (
    <div className="pincode-management-container">
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "16px",
            marginBottom: "16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <ArrowLeftOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
            <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
              Pincode Management
            </h1>
          </div>

          <div className="extra-content-wrapper">
            {activeTab !== "3" && activeTab !== "4" && activeTab !== "5" && activeTab !== "6" && (
              <div className="active-pincode-pill">
                <span className="pill-label">Show Active Pincode</span>
                <Switch size="small" checked={isActiveToggle} onChange={setIsActiveToggle} />
              </div>
            )}
            
            {/* Added check to hide generic search input when in State & City Management tab since it has its own search */}
            {activeTab !== "6" && (
              <div className="search-container">
                <InputSearchComponent
                  placeholder="Search Pincode"
                  name="search"
                  label=""
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    if (e.target.value.trim() === "") {
                      fetchData(1, pagination.pageSize, activeTab, "");
                    }
                  }}
                  onSearch={(value) => {
                    const trimmedValue = value.trim();
                    setSearchText(trimmedValue);
                    fetchData(1, pagination.pageSize, activeTab, trimmedValue);
                  }}
                />
              </div>
            )}

            {activeTab !== "3" && activeTab !== "6" && (
              <Button
                className="export-btn"
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                Export
              </Button>
            )}
            {activeTab !== "3" && activeTab !== "6" && hasWriteAccess && (
              <Button
                type="primary"
                className="add-pincode-btn"
                icon={<PlusOutlined />}
                onClick={handleAdd}
              >
                Add Pincode
              </Button>
            )}
            {activeTab === "4" && hasWriteAccess && (
              <Button
                type="primary"
                className="manage-zone-btn"
                onClick={openManageZoneModal}
                style={{ borderRadius: "6px" }}
              >
                Manage Zone
              </Button>
            )}
          </div>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="custom-tabs"
        >
          <TabPane tab="Ecomm" key="1" />
          <TabPane tab="Courier" key="2" />
          <TabPane tab="Hyperlocal" key="3" />
          <TabPane tab="Pincode metadata" key="4" />
          <TabPane tab="MCN list" key="5" />
          <TabPane tab="State & City Management" key="6" />
        </Tabs>
      </div >



        {activeTab !== "6" && activeTab !== "3" ? (
          <Spin
            spinning={loading}
            indicator={
              <img
                src={Smcs_Loader}
                style={{ width: 100, height: 100 }}
                alt="Loading..."
              />
            }
          >
            <Table
              className="pincode-table"
              dataSource={dataSource}
              columns={columns}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
              onChange={handleTableChange}
              scroll={{ y: "calc(100vh - 350px)" }}
              rowKey={(record) => record.pincode || Math.random()}
            />
          </Spin>
        ) : null}
      {/* Fallback for activeTab 3 (Hyperlocal) */}
      {
        activeTab === "3" ? (
          <div className="hyperlocal-container">
            <div className="filter-row" style={{ display: "flex", gap: "12px", alignItems: "center", marginBottom: "24px" }}>
              <Select
                placeholder="Select State"
                style={{ width: 220 }}
                value={hyperlocalState}
                onChange={handleStateChange}
                options={(hyperlocalStateList || []).map(s => {
                  const label = typeof s === "object" ? (s?.stateName || s?.state || s?.name || JSON.stringify(s)) : s;
                  return { label: label, value: label };
                })}
                showSearch
                optionFilterProp="label"
              />
              <Select
                placeholder="Select City"
                style={{ width: 220 }}
                value={hyperlocalCity}
                onChange={handleCityChange}
                options={cityList.map(c => {
                  const label = typeof c === "object" ? (c?.city || c?.cityName || c?.name || JSON.stringify(c)) : c;
                  return { label: label, value: label };
                })}
                disabled={!hyperlocalState}
                showSearch
              />
              {(hyperlocalState || hyperlocalCity) && (
                <Button
                  icon={<CloseCircleOutlined />}
                  onClick={clearHyperlocalFilters}
                  shape="circle"
                  type="text"
                  className="clear-filters-btn"
                />
              )}
              <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: "12px", alignItems: "center" }}>
                {hasWriteAccess && (
                  <Button
                    type="primary"
                    style={{ background: "var(--primary, #175EB6)", borderColor: "var(--primary, #175EB6)" }}
                    onClick={openCreateModal}
                  >
                    Create Zone
                  </Button>
                )}
              </div>
            </div>

            <Modal
              title="Create Zone"
              open={createModalVisible}
              onCancel={() => setCreateModalVisible(false)}
              footer={
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
                  <Button onClick={() => setCreateModalVisible(false)}>Cancel</Button>
                  <Button
                    type="primary"
                    style={{ background: "var(--primary, #175EB6)", borderColor: "var(--primary, #175EB6)" }}
                    onClick={handleCreateZoneSubmit}
                    loading={loading}
                    disabled={selectedPincodes.length === 0} // ← Updated condition
                  >
                    Create Zone
                  </Button>
                </div>
              }
              width={800}
              className="create-zone-modal"
            >
              <div className="zone-input-group">
                <label>Enter Zone Name *</label>
                <Input
                  placeholder="Enter zone name"
                  value={newZoneName}
                  onChange={(e) => setNewZoneName(e.target.value)}
                />
              </div>

              <div className="zone-input-group">
                <label>Search Area or Pincode</label>
                <Input.Search
                  placeholder="Search by pincode or area name"
                  value={pincodeSearch}
                  onChange={(e) => setPincodeSearch(e.target.value)}
                />
              </div>

              <div className="pincode-selection-container">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: 600 }}>Select Pincodes ({filteredAvailablePincodes.length})</span>
                  <Button type="link" onClick={() => setSelectedPincodes([])}>Clear Selection</Button>
                </div>

                {formattedLoading ? (
                  <div style={{ textAlign: "center", padding: 40 }}>
                    <Spin indicator={<img src={Smcs_Loader} style={{ width: 60, height: 60 }} alt="Loading..." />} />
                  </div>
                ) : (
                  <>
                    <div className="selection-grid">
                      {filteredAvailablePincodes.map((pin, index) => {
                        // Ensure we handle both string pincodes and object pincodes from available list if structure varies
                        // Assuming pin has 'pincode' property as per API inspection
                        const isSelected = selectedPincodes.some(p => p.pincode === pin.pincode);
                        return (
                          <div
                            key={index}
                            className={`selection-card ${isSelected ? "selected" : ""}`}
                            onClick={() => togglePincodeSelection(pin)}
                          >
                            <Checkbox checked={isSelected} />
                            <div className="card-content">
                              <div className="pincode">{pin.pincode}</div>
                              <div className="area-list">
                                {Array.isArray(pin.area) ? pin.area.join(", ") : (pin.areaName || "")}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {filteredAvailablePincodes.length === 0 && (
                      <div style={{ padding: 20, textAlign: "center", color: "#999" }}>
                        No pincodes found
                      </div>
                    )}
                  </>
                )}
              </div>
            </Modal>

            <Modal
              title="Edit Zone"
              open={editZoneModalVisible}
              onCancel={() => {
                setEditZoneModalVisible(false);
                setEditingZone(null);
              }}
              footer={
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
                  <Button onClick={() => setEditZoneModalVisible(false)}>Cancel</Button>
                  <Button
                    type="primary"
                    style={{ background: "var(--primary, #175EB6)", borderColor: "var(--primary, #175EB6)" }}
                    onClick={handleEditZoneSubmit}
                    loading={loading}
                    disabled={editSelectedPincodes.length === 0}
                  >
                    Save Changes
                  </Button>
                </div>
              }
              width={800}
              className="create-zone-modal"
            >
              <div className="zone-input-group">
                <label>Zone Name *</label>
                <Input
                  placeholder="Enter zone name"
                  value={editZoneName}
                  onChange={(e) => setEditZoneName(e.target.value)}
                />
              </div>

              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={12}>
                  <label>Order Process Type</label>
                  <Select
                    style={{ width: "100%", marginTop: 4 }}
                    value={editOrderProcessType}
                    onChange={setEditOrderProcessType}
                  >
                    <Option value="NORMAL">NORMAL</Option>
                  </Select>
                </Col>
                <Col span={12} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: 8 }}>
                  <Checkbox
                    checked={editAcceptNormalOrder}
                    onChange={(e) => setEditAcceptNormalOrder(e.target.checked)}
                  >
                    Accept Normal Order
                  </Checkbox>
                  <Checkbox
                    checked={editAcceptSubscriptionOrder}
                    onChange={(e) => setEditAcceptSubscriptionOrder(e.target.checked)}
                  >
                    Accept Subscription Order
                  </Checkbox>
                </Col>
              </Row>

              <div className="zone-input-group" style={{ marginTop: 16 }}>
                <label>Search Area or Pincode</label>
                <Input.Search
                  placeholder="Search by pincode or area name"
                  value={editPincodeSearch}
                  onChange={(e) => setEditPincodeSearch(e.target.value)}
                />
              </div>

              <div className="pincode-selection-container">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: 600 }}>
                    Serviceable Pincodes ({editSelectedPincodes.length} selected)
                  </span>
                  <Button type="link" onClick={() => setEditSelectedPincodes([])}>
                    Clear Selection
                  </Button>
                </div>

                {editZoneLoading ? (
                  <div style={{ textAlign: "center", padding: 40 }}>
                    <Spin indicator={<img src={Smcs_Loader} style={{ width: 60, height: 60 }} alt="Loading..." />} />
                  </div>
                ) : (
                  <div className="selection-grid">
                    {filteredEditAvailablePincodes.map((pin, index) => {
                      const isSelected = editSelectedPincodes.some((p) => p.pincode === pin.pincode);
                      return (
                        <div
                          key={index}
                          className={`selection-card ${isSelected ? "selected" : ""}`}
                          onClick={() => toggleEditPincodeSelection(pin)}
                        >
                          <Checkbox checked={isSelected} />
                          <div className="card-content">
                            <div className="pincode">{pin.pincode}</div>
                            <div className="area-list">
                              {Array.isArray(pin.area) ? pin.area.join(", ") : (pin.areaName || "")}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </Modal>

            {loading ? (
              <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                <Spin indicator={<img src={Smcs_Loader} style={{ width: 60, height: 60 }} alt="Loading..." />} />
              </div>
            ) : zoneList.length > 0 ? (
              <div className="zone-list-container">
                {zoneList.map((zone, index) => {
                  const isCollapsed = collapsedZones[index];
                  return (
                    <div key={index} className="zone-card">
                      <div className="zone-card-header">
                        <div className="zone-name">{zone?.zoneName || zone?.name || "Unknown Zone"}</div>
                        <div className="zone-actions">
                          {hasWriteAccess && (
                            <Button
                              type="text"
                              icon={<EditOutlined />}
                              onClick={() => openEditZoneModal(zone)}
                              aria-label="Edit zone"
                            />
                          )}
                          <Switch
                            checked={zone?.isActive !== false}
                            size="small"
                            onChange={(checked) => handleZoneToggle(zone, checked)}
                            loading={loading}
                            disabled={!hasWriteAccess}
                          />
                          <span
                            className="expand-icon"
                            onClick={() => handleCollapseToggle(index)}
                            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                          >
                            {isCollapsed ? <DownOutlined /> : <UpOutlined />}
                          </span>
                        </div>
                      </div>


                      {
                        !isCollapsed && (
                          <>
                            <div className="zone-meta-row">
                              <span className="meta-item"><strong>State:</strong> {zone?.stateName?.toUpperCase() || zone?.state?.toUpperCase() || "N/A"}</span>
                              <span className="meta-item"><strong>Order Process Type:</strong> {zone?.orderProcessType || zone?.processType || "NORMAL"}</span>
                              <span className="meta-item"><strong>Total Pincodes:</strong> {(zone?.serviceablePincodes || zone?.pincodes || []).length}</span>
                            </div>

                            <div className="serviceable-pincodes-section">
                              <div className="section-title">Serviceable Pincodes</div>
                              <div className="pincode-grid">
                                {(zone?.serviceablePincodes || zone?.pincodes || []).map((pin, pIndex) => (
                                  <div key={pIndex} className="pincode-card">
                                    <div className="pincode-number">{pin?.pincode || pin}</div>
                                    <div className="pincode-areas">
                                      {/* Handle 'area' array from API or fallback to 'localities' */}
                                      {typeof pin === "object" && (Array.isArray(pin.area) || Array.isArray(pin.localities))
                                        ? (pin.area || pin.localities).map((loc, lIndex) => <div key={lIndex} className="area-name">{loc}</div>)
                                        : <div className="area-name">{pin?.areaName || "All Localities"}</div>
                                      }
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )
                      }
                    </div>
                  );
                })}
              </div>
            ) : (
              (hyperlocalCity) &&
              <div className="empty-state-container">
                No zones found for {hyperlocalCity}
              </div>
            )}
          </div>
        ) : null
      }

      <Modal
        title={`Add Pincode - ${
          activeTab === "1"
            ? "Ecomm"
            : activeTab === "2"
              ? "Courier"
              : activeTab === "4"
                ? "Pincode Metadata"
                : "MCN List"
        }`}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={600}
        destroyOnClose
        className="add-pincode-modal"
        footer={[
          <Button key="back" onClick={handleModalCancel}>
            Close
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleModalOk}
            style={{ backgroundColor: "#1890ff" }}
          >
            {addEntryMode === "manual" && supportsManualEntry ? "Create" : "Add"}
          </Button>,
        ]}
      >
        {supportsManualEntry && (
          <Radio.Group
            value={addEntryMode}
            onChange={(e) => {
              setAddEntryMode(e.target.value);
              form.resetFields();
              setUploadedFile(null);
              if (e.target.value === "manual" && activeTab === "4") {
                fetchDropdownLists();
              }
              if (e.target.value === "manual" && (activeTab === "1" || activeTab === "2")) {
                form.setFieldsValue({
                  fm: true,
                  lm: true,
                  cod: false,
                  sdd: false,
                  ndd: false,
                });
              }
            }}
            style={{ marginBottom: 16 }}
          >
            <Radio.Button value="bulk">Bulk Upload</Radio.Button>
            <Radio.Button value="manual">Manual Entry</Radio.Button>
          </Radio.Group>
        )}

        {(addEntryMode === "bulk" || !supportsManualEntry) && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <span style={{ fontWeight: "500" }}>Bulk Upload</span>
              <Button
                type="text"
                icon={<InfoCircleOutlined />}
                onClick={() => {
                  const businessLine = getBusinessLine(activeTab);
                  const templateUrls = {
                    ecomm: "https://delcaper-prod.s3.ap-south-1.amazonaws.com/ath-template/Ecomm-bulk-upload-pincode.xlsx",
                    courier: "https://delcaper-prod.s3.ap-south-1.amazonaws.com/ath-template/Courier-bulk-upload-pincode.xlsx",
                    metadata: "https://delcaper-prod.s3.ap-south-1.amazonaws.com/ath-template/Bulk-upload-Pincode-Metadata.xlsx",
                    mcn: "https://delcaper-prod.s3.ap-south-1.amazonaws.com/ath-template/Bulk-upload-mcn.xlsx",
                  };

                  const url = templateUrls[businessLine] || templateUrls.ecomm;
                  let fileName = "Ecomm-bulk-upload-pincode.xlsx";

                  if (businessLine === "courier") fileName = "Courier-bulk-upload-pincode.xlsx";
                  else if (businessLine === "metadata") fileName = "Metadata-bulk-upload-pincode.xlsx";
                  else if (businessLine === "mcn") fileName = "MCN-bulk-upload-pincode.xlsx";

                  const link = document.createElement("a");
                  link.href = url;
                  link.download = fileName;
                  link.target = "_blank";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                className="csv-info-btn"
                style={{ color: "#1890ff" }}
              >
                Download Excel Template
              </Button>
            </div>
            <Dragger
              name="file"
              multiple={false}
              beforeUpload={(file) => {
                setUploadedFile(file);
                return false;
              }}
              onRemove={() => setUploadedFile(null)}
              fileList={uploadedFile ? [uploadedFile] : []}
              style={{
                padding: "20px",
                background: "#fafafa",
                border: "1px dashed #d9d9d9",
                borderRadius: "2px",
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined style={{ color: "#1890ff", fontSize: "48px" }} />
              </p>
              <p className="ant-upload-text">
                Drag and drop your file here, or click to browse
              </p>
              <p className="ant-upload-hint">Supports: .csv, .xlsx, .xls</p>
            </Dragger>
          </div>
        )}

        {addEntryMode === "manual" && supportsManualEntry && (
          <Form form={form} layout="vertical">
            <Form.Item
              name="pincode"
              label="Pincode"
              rules={[
                { required: true, message: "Please enter pincode" },
                { pattern: /^\d{6}$/, message: "Pincode must be 6 digits" },
              ]}
            >
              <Input maxLength={6} placeholder="6-digit pincode" />
            </Form.Item>

            {(activeTab === "1" || activeTab === "2") && (
              <>
                <div style={{ fontWeight: 500, marginBottom: 8 }}>Services</div>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="fm" valuePropName="checked">
                      <Checkbox>First Mile (FM)</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="lm" valuePropName="checked">
                      <Checkbox>Last Mile (LM)</Checkbox>
                    </Form.Item>
                  </Col>
                  {activeTab === "1" && (
                    <>
                      <Col span={8}>
                        <Form.Item name="cod" valuePropName="checked">
                          <Checkbox>COD</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item name="sdd" valuePropName="checked">
                          <Checkbox>Same Day (SDD)</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item name="ndd" valuePropName="checked">
                          <Checkbox>Next Day (NDD)</Checkbox>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
                <p style={{ fontSize: 12, color: "#888", marginTop: -8 }}>
                  Pincode must already exist in Pincode metadata with a hub assigned.
                </p>
              </>
            )}

            {activeTab === "4" && (
              <>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="state_id"
                      label="State"
                      rules={[{ required: true, message: "Please select state" }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select state"
                        optionFilterProp="children"
                        onChange={handleManualMetadataStateChange}
                      >
                        {stateList.map((state) => (
                          <Option key={state.id} value={state.id}>
                            {state.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="city"
                      label="City"
                      rules={[{ required: true, message: "Please select city" }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select city"
                        optionFilterProp="children"
                        disabled={manualMetadataCities.length === 0}
                      >
                        {manualMetadataCities.map((city) => (
                          <Option key={city.id} value={city.name}>
                            {city.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name="hub_name"
                  label="Hub Name"
                  rules={[{ required: true, message: "Please enter hub name" }]}
                >
                  <Input placeholder="Hub name (must match an existing hub)" />
                </Form.Item>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="ecomm_zone"
                      label="Ecomm Zone"
                      rules={[{ required: true, message: "Please select ecomm zone" }]}
                    >
                      <Select showSearch placeholder="Ecomm zone" optionFilterProp="children">
                        {ecommZoneList.map((z) => (
                          <Option key={z.id} value={z.name}>
                            {z.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="courier_zone"
                      label="Courier Zone"
                      rules={[{ required: true, message: "Please select courier zone" }]}
                    >
                      <Select showSearch placeholder="Courier zone" optionFilterProp="children">
                        {courierZoneList.map((z) => (
                          <Option key={z.id} value={z.name}>
                            {z.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="ecomm_billing_zone"
                      label="Ecomm Billing Zone"
                      rules={[{ required: true, message: "Please select ecomm billing zone" }]}
                    >
                      <Select showSearch placeholder="Ecomm billing zone" optionFilterProp="children">
                        {ecommBillingZoneList.map((z) => (
                          <Option key={z.id} value={z.name}>
                            {z.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="courier_billing_zone" label="Courier Billing Zone">
                      <Select showSearch allowClear placeholder="Courier billing zone (optional)" optionFilterProp="children">
                        {courierBillingZoneList.map((z) => (
                          <Option key={z.id} value={z.name}>
                            {z.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="tat_in_hours"
                      label="Transit Hours for Delivery"
                      rules={[{ required: true, message: "Required" }]}
                    >
                      <InputNumber min={1} style={{ width: "100%" }} placeholder="Hours" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="pickup_tat_in_hours" label="Transit Hours for Pickup">
                      <InputNumber min={1} style={{ width: "100%" }} placeholder="Hours (optional)" />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </Form>
        )}
      </Modal>

      {/* Manage Zone Modal */}
      <Modal
        title="Manage Zone"
        visible={manageZoneModalVisible}
        onCancel={() => setManageZoneModalVisible(false)}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <div style={{ padding: "0 0" }}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
            <Button onClick={() => handleOpenCreateEntity("zone")} style={{ marginRight: 8 }}>+ Create Zone</Button>
            <Button onClick={() => handleOpenCreateEntity("billing")}>+ Create Billing Zone</Button>
          </div>

          <div style={{ borderTop: "1px solid #f0f0f0", margin: "20px 0" }}></div>




          <div style={{ marginTop: "20px", marginBottom: "20px", padding: "16px", background: "#f5f5f5", borderRadius: "8px" }}>
            <div style={{ fontWeight: "bold", marginBottom: "12px" }}>Bulk Update Zones</div>
            
            
            {/* Pincode Input */}
            <div style={{ marginBottom: "16px" }}>
              <div style={{ fontSize: "12px", marginBottom: "4px", fontWeight: "500" }}>
                Pincodes (Enter 6-digit pincodes)
              </div>
              <Input
                placeholder="Type pincode and press Enter (e.g., 411001, 411002 411003)"
                value={bulkPincodeText}
                onChange={(e) => setBulkPincodeText(e.target.value)}
                onKeyPress={handlePincodeInputKeyPress}
                onBlur={handleAddPincodes}
                style={{ width: "100%" }}
              />
              <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>
                Paste comma or space separated pincodes and press Enter. Each pincode must be exactly 6 digits.
              </div>
              
              {/* Display selected pincodes as tags */}
              {bulkPincodeList.length > 0 && (
                <div style={{ marginTop: "12px", padding: "8px", border: "1px dashed #d9d9d9", borderRadius: "4px", background: "#fff" }}>
                  <div style={{ marginBottom: "8px", fontSize: "12px", fontWeight: "500", color: "#666", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Selected Pincodes ({bulkPincodeList.length}):</span>
                    <Button 
                      size="small" 
                      type="link" 
                      danger
                      onClick={() => setBulkPincodeList([])}
                      style={{ padding: "0 4px" }}
                    >
                      Clear All
                    </Button>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", maxHeight: "120px", overflowY: "auto" }}>
                    {bulkPincodeList.map((pincode) => (
                      <Tag 
                        key={pincode} 
                        closable 
                        onClose={() => handleRemoveBulkPincode(pincode)}
                        color="blue"
                      >
                        {pincode}
                      </Tag>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Row gutter={16}>
              <Col span={5}>
                <div style={{ fontSize: "12px", marginBottom: "4px" }}>Ecomm Zone (Optional)</div>
                <Select
                  showSearch
                  allowClear
                  placeholder="Ecomm Zone"
                  value={bulkEcommZone}
                  onChange={(val) => setBulkEcommZone(val)}
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {ecommZoneList.map((z) => (
                    <Option key={z.id} value={z.id}>
                      {z.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={5}>
                <div style={{ fontSize: "12px", marginBottom: "4px" }}>Courier Zone (Optional)</div>
                <Select
                  showSearch
                  allowClear
                  placeholder="Courier Zone"
                  value={bulkCourierZone}
                  onChange={(val) => setBulkCourierZone(val)}
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {courierZoneList.map((z) => (
                    <Option key={z.id} value={z.id}>
                      {z.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={5}>
                <div style={{ fontSize: "12px", marginBottom: "4px" }}>Ecomm Billing (Optional)</div>
                <Select
                  showSearch
                  allowClear
                  placeholder="Ecomm Billing"
                  value={bulkEcommBillingZone}
                  onChange={(val) => setBulkEcommBillingZone(val)}
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {ecommBillingZoneList.map((z) => (
                    <Option key={z.id} value={z.id}>
                      {z.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={5}>
                <div style={{ fontSize: "12px", marginBottom: "4px" }}>Courier Billing (Optional)</div>
                <Select
                  showSearch
                  allowClear
                  placeholder="Courier Billing"
                  value={bulkCourierBillingZone}
                  onChange={(val) => setBulkCourierBillingZone(val)}
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {courierBillingZoneList.map((z) => (
                    <Option key={z.id} value={z.id}>
                      {z.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={4} style={{ display: "flex", alignItems: "flex-end" }}>
                <Button type="primary" onClick={handleBulkUpdate} style={{ width: "100%" }}>
                  Update
                </Button>
              </Col>
            </Row>
          </div>

          <div style={{ marginTop: "20px" }}>
            <div style={{ marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Input
                placeholder="Search Pincode"
                value={manageZoneSearchText}
                onChange={(e) => {
                  const val = e.target.value;
                  setManageZoneSearchText(val);
                  if (val === "") {
                    setManageZonePage(1);
                    fetchManageZoneData(1, "");
                  }
                }}
                onPressEnter={() => {
                  setManageZonePage(1);
                  fetchManageZoneData(1, manageZoneSearchText);
                }}
                style={{ width: 300 }}
                allowClear
              />
            </div>

            <Table
              dataSource={manageZoneTableData}
              columns={manageZoneColumns}
              loading={manageZoneLoading}
              pagination={{
                current: manageZonePage,
                pageSize: 10,
                total: manageZoneTotal,
                onChange: (page) => fetchManageZoneData(page),
              }}
              rowKey="id"
              size="small"
              bordered
            />
          </div>

        </div>
      </Modal>

      {/* State & City Management View */}
      {activeTab === "6" && (
        <div style={{ marginTop: "24px", padding: "16px", background: "#fff", borderRadius: "8px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
            <div style={{ display: "flex", gap: "16px" }}>
              <Select
                showSearch
                placeholder="Select State"
                style={{ width: "300px" }}
                value={managementState}
                onChange={(value) => {
                  setManagementState(value);
                  // Fetch cities for this state
                  setManagementLoading(true);
                  PincodeService.getServiceabilityCities(value)
                    .then(cities => {
                      setManagementCities(cities);
                    })
                    .catch(() => {
                      message.error("Failed to load cities");
                      setManagementCities([]);
                    })
                    .finally(() => setManagementLoading(false));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {stateList.map((st) => (
                  <Option key={st.id} value={st.id}>{st.name}</Option>
                ))}
              </Select>

              {managementState && (
                <Input
                  placeholder="Search City..."
                  value={managementCitySearch}
                  onChange={(e) => setManagementCitySearch(e.target.value)}
                  style={{ width: "250px" }}
                  prefix={<SearchOutlined />}
                  allowClear
                />
              )}
            </div>

            <Button
              type="primary"
              icon={<PlusOutlined />}
              disabled={!hasWriteAccess}
              onClick={() => {
                setCityModalMode("add");
                setEditingCity(null);
                form.resetFields(["cityName", "state_id"]);
                if (managementState) {
                  form.setFieldsValue({ state_id: managementState });
                }
                setCityModalVisible(true);
              }}
            >
              Add City
            </Button>
          </div>

          <Table
            dataSource={managementCities.filter(city => city.name.toLowerCase().includes(managementCitySearch.toLowerCase()))}
            loading={managementLoading}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            columns={[
              { title: "ID", dataIndex: "id", key: "id", width: 80 },
              { title: "City Name", dataIndex: "name", key: "name" },
              {
                title: "Action",
                key: "action",
                width: 120,
                render: (_, record) => (
                  <Button
                    type="link"
                    icon={<EditOutlined />}
                    disabled={!hasWriteAccess}
                    onClick={() => {
                      setCityModalMode("edit");
                      setEditingCity(record);
                      form.setFieldsValue({ cityName: record.name });
                      setCityModalVisible(true);
                    }}
                  >
                    Edit
                  </Button>
                )
              }
            ]}
          />
        </div>
      )}

      {/* Add / Edit City Modal */}
      <Modal
        title={cityModalMode === "add" ? "Add City" : "Edit City"}
        visible={cityModalVisible}
        onCancel={() => {
          setCityModalVisible(false);
          form.resetFields(["cityName", "state_id"]);
        }}
        confirmLoading={managementLoading}
        onOk={async () => {
          try {
            const fieldsToValidate = cityModalMode === "add" ? ["cityName", "state_id"] : ["cityName"];
            const values = await form.validateFields(fieldsToValidate);
            setManagementLoading(true);

            if (cityModalMode === "add") {
              await PincodeService.createCity({
                name: values.cityName,
                state_id: values.state_id
              });
              message.success("City created successfully");
            } else {
              await PincodeService.updateCity(editingCity.id, {
                name: values.cityName
              });
              message.success("City updated successfully");
            }

            setCityModalVisible(false);
            form.resetFields(["cityName", "state_id"]);

            // Refresh list if the city was added to the currently viewed state, or always refresh
            if (managementState) {
              const updatedCities = await PincodeService.getServiceabilityCities(managementState);
              setManagementCities(updatedCities);
            }
          } catch (error) {
            console.error("City operation failed", error);
            const errorMsg = error?.response?.data?.message || error?.message || "City operation failed";
            message.error(errorMsg);
          } finally {
            setManagementLoading(false);
          }
        }}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          {cityModalMode === "add" && (
            <Form.Item
              name="state_id"
              label="State"
              rules={[{ required: true, message: "Please select a state" }]}
            >
              <Select
                showSearch
                placeholder="Select State"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {stateList.map((st) => (
                  <Option key={st.id} value={st.id}>{st.name}</Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item
            name="cityName"
            label="City Name"
            rules={[{ required: true, message: "Please enter a city name" }]}
          >
            <Input placeholder="e.g. Pune" />
          </Form.Item>
        </Form>
      </Modal>

      {/* Create Entity Modal */}
      <Modal
        title={`Create ${entityType === "zone" ? "Zone" : "Billing Zone"}`}
        visible={createEntityModalVisible}
        onCancel={() => setCreateEntityModalVisible(false)}
        onOk={handleCreateEntity}
        confirmLoading={manageZoneLoading}
        width={400}
        destroyOnClose
      >
        <div style={{ marginBottom: "16px" }}>
          <div style={{ marginBottom: "8px" }}>Business Line</div>
          <Radio.Group
            value={newEntityBusinessLine}
            onChange={(e) => setNewEntityBusinessLine(e.target.value)}
          >
            <Radio value="ecomm">Ecomm</Radio>
            <Radio value="courier">Courier</Radio>
          </Radio.Group>
        </div>
        <div>
          <div style={{ marginBottom: "8px" }}>Name</div>
          <Input
            placeholder="Enter name"
            value={newEntityName}
            onChange={(e) => setNewEntityName(e.target.value)}
          />
        </div>
      </Modal>

      {/* Bulk Upload Validation Errors Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span>Bulk Upload Results with Errors</span>
          </div>
        }
        visible={uploadErrorModalVisible}
        onCancel={() => setUploadErrorModalVisible(false)}
        width={800}
        footer={[
          <Button key="close" type="primary" onClick={() => setUploadErrorModalVisible(false)}>
            Close
          </Button>
        ]}
      >
        <div style={{ marginBottom: "16px", padding: "12px", background: "#f0f0f0", borderRadius: "4px" }}>
          <div style={{ marginBottom: "8px" }}>
            <strong>Total Rows Processed:</strong>{" "}
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              {uploadSuccessCount + uploadErrorData.length}
            </span>{" "}
            row(s)
          </div>
          <div style={{ marginBottom: "8px" }}>
            <strong>Successfully Inserted:</strong>{" "}
            <span style={{ color: "#52c41a", fontSize: "16px", fontWeight: "bold" }}>
              {uploadSuccessCount}
            </span>{" "}
            row(s)
          </div>
          <div>
            <strong>Failed to Insert:</strong>{" "}
            <span style={{ color: "#ff4d4f", fontSize: "16px", fontWeight: "bold" }}>
              {uploadErrorData.length}
            </span>{" "}
            row(s)
          </div>
        </div>

        <div style={{ marginBottom: "16px", color: "#666" }}>
          The following rows failed due to validation errors. Please fix these issues and try again.
        </div>
        <Table
          dataSource={uploadErrorData}
          columns={[
            {
              title: "Row",
              dataIndex: "row",
              key: "row",
              width: 100,
            },
            {
              title: "Error Message",
              dataIndex: "error",
              key: "error",
            }
          ]}
          pagination={{ pageSize: 10 }}
          rowKey={(record, index) => `${record.row}-${index}`}
          size="small"
          scroll={{ y: 400 }}
          bordered
        />
      </Modal>

      {/* Failed Pincodes Modal */}
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ color: "#ff4d4f" }}>⚠️</span>
            <span>Bulk Update - Failed Pincodes</span>
          </div>
        }
        visible={failedPincodesModalVisible}
        onCancel={() => setFailedPincodesModalVisible(false)}
        width={600}
        footer={[
          <Button key="close" onClick={() => setFailedPincodesModalVisible(false)}>
            Close
          </Button>,
          <Button
            key="copy"
            type="primary"
            icon={<CheckOutlined />}
            onClick={() => {
              const failedText = failedPincodesData.failedPincodes.join(" ");
              navigator.clipboard.writeText(failedText);
              message.success("Failed pincodes copied to clipboard!");
            }}
          >
            Copy Failed Pincodes
          </Button>,
        ]}
      >
        <div>
          {/* Summary */}
          <div style={{ marginBottom: "16px", padding: "12px", background: "#f0f0f0", borderRadius: "4px" }}>
            <div style={{ marginBottom: "8px" }}>
              <strong>✅ Successfully updated:</strong> <span style={{ color: "#52c41a", fontSize: "16px", fontWeight: "bold" }}>{failedPincodesData.successCount}</span> pincode(s)
            </div>
            <div>
              <strong>❌ Failed to update:</strong> <span style={{ color: "#ff4d4f", fontSize: "16px", fontWeight: "bold" }}>{failedPincodesData.failedPincodes.length}</span> pincode(s)
            </div>
          </div>

          {/* Instructions */}
          <div style={{ marginBottom: "12px", fontSize: "13px", color: "#666" }}>
            <strong>Failed Pincodes (space-separated):</strong>
            <div style={{ marginTop: "4px" }}>
              Copy these pincodes to retry or investigate further.
            </div>
          </div>

          {/* Copyable Textarea */}
          <Input.TextArea
            value={failedPincodesData.failedPincodes.join(" ")}
            readOnly
            rows={6}
            style={{
              fontFamily: "monospace",
              fontSize: "13px",
              background: "#fff1f0",
              border: "1px solid #ffccc7",
              color: "#000",
            }}
          />

          {/* Help Text */}
          <div style={{ marginTop: "12px", fontSize: "12px", color: "#999" }}>
            💡 <strong>Tip:</strong> These pincodes may not exist in the database or have invalid zone mappings. Click &quot;Copy Failed Pincodes&quot; to copy them to your clipboard.
          </div>
        </div>
      </Modal>
    </div >
  );
};

export default PincodeManagement;
